/**
 * La domanda "posso lasciare questa schermata?".
 *
 * Il menu del gestionale non naviga con collegamenti: chiama
 * `navigate`. Un controllo sui click dei link non lo vede passare, e
 * un modulo compilato a metà si perdeva cliccando una voce della barra
 * a sinistra - senza che niente lo chiedesse.
 *
 * Una schermata con modifiche aperte lascia qui la sua domanda; chi
 * sposta la navigazione la fa prima di muoversi. Una sola alla volta:
 * c'è una schermata sola a fuoco.
 */
let domanda = null;

export const chiediPrimaDiUscire = (fn) => { domanda = fn; };

export const smettiDiChiedere = (fn) => {
  // Solo chi l'ha messa la toglie: altrimenti lo smontaggio di una
  // schermata vecchia spegnerebbe la guardia di quella nuova.
  if (domanda === fn) domanda = null;
};

export const siPuoUscire = () => (domanda ? domanda() : true);
